import React from 'react';
import PropTypes from 'prop-types';
import symbols from './symbol-defs.svg';

const Emoji = ({ name, className }) => (
  <svg width="1em" height="1em"><use xlinkHref={symbols + "#" + name} /></svg>
);

Emoji.propTypes = {
  name: PropTypes.string.isRequired
};

export { Emoji };



// WEBPACK FOOTER //
// ./src/elements/emoji/emoji.js